import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  PublishWorkflowResponse,
  SKIP_ERROR_HANDLING_HEADER,
  StartWorkflowResponse,
  TASK_SERVER_BASE_URL,
} from '@qtek/shared/models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WorkflowFlowableService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${inject(TASK_SERVER_BASE_URL)}/api/v2/flowable/workflows`;
  // WorkflowStore surfaces publish/start failures itself.
  private readonly options = {
    withCredentials: true,
    headers: new HttpHeaders().append(SKIP_ERROR_HANDLING_HEADER, ''),
  };

  publish(workflowId: string): Observable<PublishWorkflowResponse> {
    return this.http.post<PublishWorkflowResponse>(
      `${this.baseUrl}/${workflowId}/publish`,
      {},
      this.options
    );
  }
  start(workflowId: string, itemId: string): Observable<StartWorkflowResponse> {
    return this.http.post<StartWorkflowResponse>(
      `${this.baseUrl}/${workflowId}/start`,
      { itemId },
      this.options
    );
  }
}
